import { render } from "./search-result-panel.vue?vue&type=template&id=0dd28500&ts=true"
import script from "./search-result-panel.vue?vue&type=script&lang=ts"
export * from "./search-result-panel.vue?vue&type=script&lang=ts"

import "./search-result-panel.vue?vue&type=style&index=0&id=0dd28500&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__